<template>
	<div class="loan-information">
		<b-card no-body>
			<b-card-header class="py-2 px-3">
				<b-row align-v="center">
					<b-col cols="6">
						<h3 class="mb-0">
							Loan Information
						</h3>
					</b-col>
					<!-- <b-col cols="6" class="text-right" v-if="!is_full">
						<b-link href="javascript:void(0)" @click="modals.show_loan_info_full_view = true">
							<b-icon icon="eye-fill" variant="primary"></b-icon>
							Full View
						</b-link>
					</b-col> -->
				</b-row>
			</b-card-header>
			<!-- <div v-if="tableData.length > 0" class="rounded-bottom"> -->
			<div v-if="tableData.length > 0" class="card-table">
				<b-row class="p-3" v-if="!is_full">
					<b-col cols="12" sm="4" md="4">
						<b-form-group class="mb-0">
							<p class="text-xs">CCRIS Date</p>
							<el-date-picker v-model="ccris_date" type="date" value-format="yyyy-MM-dd" placeholder="Pick a day">
							</el-date-picker>
						</b-form-group>
					</b-col>
				</b-row>
				<b-table-simple responsive bordered class="table-simple">
					<b-thead head-variant="primary">
						<b-tr>
							<b-th rowspan="2">No.</b-th>
							<b-th rowspan="2">Date/R&R</b-th>
							<b-th rowspan="2">STS</b-th>
							<b-th rowspan="2">Capacity</b-th>
							<b-th rowspan="2">Lender<br> Type</b-th>
							<b-th rowspan="2">Facility</b-th>
							<b-th rowspan="2">Total O/S<br> Balance (RM)</b-th>
							<b-th rowspan="2">Date Balance<br> Updated</b-th>
							<b-th rowspan="2">Limit/Instl.<br> Amt. (RM)</b-th>
							<b-th rowspan="2">Prin. Rpmt.<br> Term</b-th>
							<b-th rowspan="2">Col<br> Type</b-th>
							<b-th colspan="12" class="pb-0">
								<div class="d-flex justify-content-between">
									Conduct of Acc. for Last 12 Months
									<small v-if="!_gHlp.isEmpty(filteredData)">(From {{ commitmentMonthlyStartDate + ' untill ' +
										commitmentMonthlyEndDate }})</small>
								</div>
							</b-th>
							<b-th rowspan="2">LGL<br> Sts</b-th>
							<b-th rowspan="2">Date Sta.<br> Updated</b-th>
						</b-tr>
						<b-tr>
							<b-th v-for="(month, index) in commitmentMonthly" :key="month.month_id" class="pt-0 pb-1">{{
								monthAbbreviation(month.month_month) + (index === 0 || index === 11 ? ' `' +
									month.month_year.toString().slice(-2) : '') }}</b-th>
						</b-tr>
					</b-thead>
					<b-tbody v-for="(item, index) in filteredData" :key="item.commitment_id" class="text-center">
						<b-tr>
							<b-td>{{ index + 1 }}</b-td>
							<b-td>{{ item.commitment_approved_date }}</b-td>
							<b-td>{{ item.commitment_status }}</b-td>
							<b-td>{{ item.commitment_capacity }}</b-td>
							<b-td>{{ item.commitment_lender_type }}</b-td>
							<!-- <b-td>{{ item.commitment_loan_statue }}</b-td> -->
							<b-td>{{ item.commitment_facility }}</b-td>
							<b-td>{{ item.commitment_current_outstanding === '0.00' ? '' :
								parseFloat(item.commitment_current_outstanding).toLocaleString(undefined, { minimumFractionDigits: 2 })
								}}</b-td>
							<b-td>{{ item.commitment_date_balance_updated }}</b-td>
							<b-td>{{ item.commitment_credit_limit | moneyFormatter }}</b-td>
							<b-td>{{ item.commitment_repay_term }}</b-td>
							<b-td>{{ item.commitment_col_type }}</b-td>
							<b-td v-for="conduct in item.commitment_monthly" :key="conduct.month_id">{{ conduct.month_inst_arrears
								}}</b-td>
							<b-td>{{ item.commitment_legal_status }}</b-td>
							<b-td>{{ item.commitment_legal_date }}</b-td>
						</b-tr>
						<b-tr v-for="sub_item in item.commitment_sub_items" :key="sub_item.commitment_id">
							<b-td></b-td>
							<b-td>{{ sub_item.commitment_approved_date === item.commitment_approved_date ? '' :
								sub_item.commitment_approved_date }}</b-td>
							<b-td>{{ sub_item.commitment_status === item.commitment_status ? '' : sub_item.commitment_status }}</b-td>
							<b-td>{{ sub_item.commitment_capacity === item.commitment_capacity ? '' : sub_item.commitment_capacity
								}}</b-td>
							<b-td>{{ sub_item.commitment_lender_type === item.commitment_lender_type ? '' :
								sub_item.commitment_lender_type }}</b-td>
							<b-td>{{ sub_item.commitment_loan_statue === item.commitment_loan_statue ? '' : sub_item.commitment_loan_statue }}</b-td>
							<!-- <b-td>{{ sub_item.commitment_facility }}</b-td> -->
							<b-td>{{ sub_item.commitment_current_outstanding === item.commitment_current_outstanding ||
								sub_item.commitment_current_outstanding === '0.00' ? '' :
								parseFloat(sub_item.commitment_current_outstanding).toLocaleString(undefined, {
									minimumFractionDigits: 2
								})
								}}</b-td>
							<b-td>{{ sub_item.commitment_date_balance_updated === item.commitment_date_balance_updated ? '' :
								sub_item.commitment_date_balance_updated }}</b-td>
							<b-td>{{ sub_item.commitment_current_installment | moneyFormatter }}</b-td>
							<b-td>{{ sub_item.commitment_repay_term === item.commitment_repay_term ? '' :
								sub_item.commitment_repay_term
								}}</b-td>
							<b-td>{{ sub_item.commitment_col_type === item.commitment_col_type ? '' : sub_item.commitment_col_type
								}}</b-td>
							<b-td v-for="conduct in sub_item.commitment_monthly" :key="conduct.month_id"
								:style="{ 'background-color': conduct.month_inst_arrears !== '0' && conduct.month_inst_arrears !== '' ? '#ffe7e7' : '' }">{{
									conduct.month_inst_arrears }}</b-td>
							<b-td>{{ sub_item.commitment_legal_status === item.commitment_legal_status ? '' :
								sub_item.commitment_legal_status }}</b-td>
							<b-td>{{ sub_item.commitment_legal_date === item.commitment_legal_date ? '' :
								sub_item.commitment_legal_date
								}}</b-td>
						</b-tr>
					</b-tbody>
				</b-table-simple>
			</div>
			<div v-else class="bg-light p-3 text-center rounded-bottom">
				<p class="text-xs">No Loan Information recorded</p>
			</div>
		</b-card>
	</div>
</template>
<script>
import { Card, Button, DatePicker, Table, TableColumn } from 'element-ui'
// import LoanInformationModal from '@/views/CustomerProfile/CustomerModals/LoanInformationModal.vue'

export default {
	name: 'loan-information',
	props: ['loan_information','is_full'],
	components: {
		[Card.name]: Card,
		[Button.name]: Button,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
		[DatePicker.name]: DatePicker,
	},
	data() {
		return {
			tableData: this.loan_information,
			ccris_date: '',
			modals: {
				show_loan_info_full_view: false
			},
		}
	},
	computed: {
		filteredData() {
			if (!this.ccris_date) return this.tableData; // if no date selected, return all data
			return this.tableData.filter(
				(row) => row.commitment_approved_date == this.ccris_date
			);
		},
		commitmentMonthly() {
			return _gHlp.getValue(this.filterData, '0.commitment_monthly')
		},
		commitmentMonthlyStartDate() {
			return _gHlp.getValue(this.commitmentMonthly, '0.month_position_date')
		},
		commitmentMonthlyEndDate() {
			return _gHlp.getValue(this.commitmentMonthly, '11.month_position_date')
		},
		monthAbbreviation() {
			return function (monthNumber) {
				switch (monthNumber) {
					case 1:
						return 'J';
					case 2:
						return 'F';
					case 3:
						return 'M';
					case 4:
						return 'A';
					case 5:
						return 'M';
					case 6:
						return 'J';
					case 7:
						return 'J';
					case 8:
						return 'A';
					case 9:
						return 'S';
					case 10:
						return 'O';
					case 11:
						return 'N';
					case 12:
						return 'D';
					default:
						return '';
				}
			};
		}
	},
	methods: {
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = 'Total';
					return;
				}
				const values = data.map(item => Number(item[column.property]));
				if (!values.every(value => isNaN(value))) {
					sums[index] = 'RM ' + values.reduce((prev, curr) => {
						const value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
					}, 0).toLocaleString(undefined, { minimumFractionDigits: 2 });
				} else {
					sums[index] = '';
				}
			});

			return sums;
		},
		filterData() {
			this.filteredData = this.tableData.filter(
				(row) => row.commitment_approved_date === this.ccris_date
			);
		},
		toggleModal() {
			this.modals.view_full = !this.modals.view_full
		}
	}
}
</script>